// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f1daba9","239":"5f6b385a","455":"f30516ad"}[chunkId] + ".chunk.js";
};